import { required, dataMember, typedArray } from 'santee-dcts';
import { deserializers } from '../../core';
import * as moment from 'moment';

export class SponsorStudyKitReport {

    @dataMember()
    @required({ nullable: true })
    public kitTypeId: number;

    @dataMember()
    @required({ nullable: true })
    public ctSiteId: number;

    @dataMember()
    @required({ nullable: true })
    public siteId: number;

    @dataMember()
    @required({ nullable: true })
    public investigatorFullName: string;

    @dataMember()
    @required({ nullable: true })
    public siteNumber: string;

    @dataMember()
    @required({ nullable: true })
    public country: string;

    @dataMember()
    @required({ nullable: true })
    public region: string;

    @dataMember()
    @required({ nullable: true })
    public subprotocolId: number;

    @dataMember()
    @required({ nullable: true })
    public kitType: string;

    @dataMember()
    @required({ nullable: true })
    public description: string;

    @dataMember()
    @required({ nullable: true })
    public status: string;

    @dataMember()
    @required({ nullable: true })
    public pending: number;

    @dataMember()
    @required({ nullable: true })
    public shipped: number;

    @dataMember()
    @required({ nullable: true })
    public received: number;

    @dataMember()
    @required({ nullable: true })
    public adjusted: number;

    @dataMember()
    @required({ nullable: true })
    public onHand: number;

    @dataMember({ customDeserializer: value => moment(value) })
    @required({ nullable: true })
    public lastShipmentDate: moment.Moment;

    @dataMember()
    @required({ nullable: true })
    public projectNumber: number;

    @dataMember()
    @required({ nullable: true })
    public lastshipmentQuantity: number;
}

export class SponsorStudyKitReportReadModel {
    @dataMember()
    @required()
    @typedArray(SponsorStudyKitReport)
    public kitReports: SponsorStudyKitReport[];
}
